module.exports = __webpack_public_path__ + "static/img/Tom_Papley_mobile.6efac78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Papley_mobile.jpg
// module id = f2uS
// module chunks = 0